import { createSlice } from "@reduxjs/toolkit";
import { getReportsAPI } from "../../api/reports";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getReportsSlice = createSlice({
  name: "getReports",
  initialState: data,
  reducers: {
    getReportsSlice(state) {
      state.isLoading = true;
    },
    getReportsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getReportsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getReportsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getReportsHandler: any = (id: any, data: any) => async (dispatch: any) => {
  try {
    
    dispatch(getReportsAction.getReportsSlice());
    const response: any = await getReportsAPI(id, data);

    dispatch(getReportsAction.getReportsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getReportsAction.getReportsSliceFailure(e?.response?.data));
  }
};
export default getReportsSlice.reducer;
export const getReportsAction = getReportsSlice.actions;
